export type Money = { currency: string; value: number }

export type MoneyFormatterOptions = {
  fractionDigits?: number
}

export const normalizeMoney = (amount: Money) => amount.value / 100

export const formatMoney = (amount?: Money, options?: MoneyFormatterOptions) => {
  if (!amount) return ''

  return new Intl.NumberFormat('en-US', {
    currency: amount.currency,
    maximumFractionDigits: options?.fractionDigits ?? 2,
    minimumFractionDigits: options?.fractionDigits ?? 2,
    style: 'currency',
  }).format(normalizeMoney(amount))
}
